import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

export type MeResponse = {
  id: string;
  name: string;
  tenantId: string;
  isAdmin: boolean;
};

export const meKeys = { all: ['me'] as const };

export const meQueries = {
  detail: () =>
    queryOptions({
      queryKey: meKeys.all,
      queryFn: (): Promise<MeResponse> => apiFetch<MeResponse>('/me'),
      staleTime: 5 * 60_000,
    }),
};

export const useMe = () => useQuery(meQueries.detail());
